<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M12.5999 3.17471C12.5999 3.50608 12.3313 3.77471 11.9999 3.77471C11.6685 3.77471 11.3999 3.50608 11.3999 3.17471C11.3999 2.84334 11.6685 2.57471 11.9999 2.57471C12.3313 2.57471 12.5999 2.84334 12.5999 3.17471Z"
      :class="colorClass"
    />
    <path
      d="M6.78286 4.78252C7.11423 4.78252 7.38286 4.51389 7.38286 4.18252C7.38286 3.85115 7.11423 3.58252 6.78286 3.58252C6.45149 3.58252 6.18286 3.85115 6.18286 4.18252C6.18286 4.51389 6.45149 4.78252 6.78286 4.78252Z"
      :class="colorClass"
    />
    <path
      d="M3.61978 7.74028C3.95115 7.74028 4.21978 7.47165 4.21978 7.14028C4.21978 6.80891 3.95115 6.54028 3.61978 6.54028C3.2884 6.54028 3.01978 6.80891 3.01978 7.14028C3.01978 7.47165 3.2884 7.74028 3.61978 7.74028Z"
      :class="colorClass"
    />
    <path
      d="M3.23418 11.6774C3.23418 12.0088 2.96555 12.2774 2.63418 12.2774C2.30281 12.2774 2.03418 12.0088 2.03418 11.6774C2.03418 11.346 2.30281 11.0774 2.63418 11.0774C2.96555 11.0774 3.23418 11.346 3.23418 11.6774Z"
      :class="colorClass"
    />
    <path
      d="M3.61978 18.4834C3.95115 18.4834 4.21978 18.2148 4.21978 17.8834C4.21978 17.5521 3.95115 17.2834 3.61978 17.2834C3.2884 17.2834 3.01978 17.5521 3.01978 17.8834C3.01978 18.2148 3.2884 18.4834 3.61978 18.4834Z"
      :class="colorClass"
    />
    <path
      d="M6.18291 10.5794C6.70758 10.5794 7.13291 10.1541 7.13291 9.62944C7.13291 9.10477 6.70758 8.67944 6.18291 8.67944C5.65824 8.67944 5.23291 9.10477 5.23291 9.62944C5.23291 10.1541 5.65824 10.5794 6.18291 10.5794Z"
      :class="colorClass"
    />
    <path
      d="M6.18296 14.6194C6.18296 15.1441 5.75763 15.5694 5.23296 15.5694C4.70829 15.5694 4.28296 15.1441 4.28296 14.6194C4.28296 14.0948 4.70829 13.6694 5.23296 13.6694C5.75763 13.6694 6.18296 14.0948 6.18296 14.6194Z"
      :class="colorClass"
    />
    <path
      d="M9.6436 7.38828C10.1683 7.38828 10.5936 6.96295 10.5936 6.43828C10.5936 5.91361 10.1683 5.48828 9.6436 5.48828C9.11893 5.48828 8.6936 5.91361 8.6936 6.43828C8.6936 6.96295 9.11893 7.38828 9.6436 7.38828Z"
      :class="colorClass"
    />
    <path
      d="M16.6169 4.18252C16.6169 4.51389 16.8855 4.78252 17.2169 4.78252C17.5483 4.78252 17.8169 4.51389 17.8169 4.18252C17.8169 3.85115 17.5483 3.58252 17.2169 3.58252C16.8855 3.58252 16.6169 3.85115 16.6169 4.18252Z"
      :class="colorClass"
    />
    <path
      d="M20.38 7.74028C20.0486 7.74028 19.78 7.47165 19.78 7.14028C19.78 6.80891 20.0486 6.54028 20.38 6.54028C20.7114 6.54028 20.98 6.80891 20.98 7.14028C20.98 7.47165 20.7114 7.74028 20.38 7.74028Z"
      :class="colorClass"
    />
    <path
      d="M20.7661 11.6774C20.7661 12.0088 21.0347 12.2774 21.3661 12.2774C21.6974 12.2774 21.9661 12.0088 21.9661 11.6774C21.9661 11.346 21.6974 11.0774 21.3661 11.0774C21.0347 11.0774 20.7661 11.346 20.7661 11.6774Z"
      :class="colorClass"
    />
    <path
      d="M20.38 18.4834C20.0486 18.4834 19.78 18.2148 19.78 17.8834C19.78 17.5521 20.0486 17.2834 20.38 17.2834C20.7114 17.2834 20.98 17.5521 20.98 17.8834C20.98 18.2148 20.7114 18.4834 20.38 18.4834Z"
      :class="colorClass"
    />
    <path
      d="M16.8668 9.62944C16.8668 10.1541 17.2922 10.5794 17.8168 10.5794C18.3415 10.5794 18.7668 10.1541 18.7668 9.62944C18.7668 9.10477 18.3415 8.67944 17.8168 8.67944C17.2922 8.67944 16.8668 9.10477 16.8668 9.62944Z"
      :class="colorClass"
    />
    <path
      d="M18.7663 15.5694C18.2416 15.5694 17.8163 15.1441 17.8163 14.6194C17.8163 14.0948 18.2416 13.6694 18.7663 13.6694C19.291 13.6694 19.7163 14.0948 19.7163 14.6194C19.7163 15.1441 19.291 15.5694 18.7663 15.5694Z"
      :class="colorClass"
    />
    <path
      d="M13.4062 6.43828C13.4062 6.96295 13.8315 7.38828 14.3562 7.38828C14.8808 7.38828 15.3062 6.96295 15.3062 6.43828C15.3062 5.91361 14.8808 5.48828 14.3562 5.48828C13.8315 5.48828 13.4062 5.91361 13.4062 6.43828Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.24561 13.2577C8.24561 11.1841 9.92657 9.50317 12.0001 9.50317C14.0737 9.50317 15.7547 11.1841 15.7547 13.2577C15.7547 14.2929 15.3358 15.2302 14.6582 15.9094C16.7835 16.9262 17.7791 19.0726 17.7791 20.8252C17.7791 21.1565 17.5104 21.4252 17.1791 21.4252C16.8477 21.4252 16.5791 21.1565 16.5791 20.8252C16.5791 19.2993 15.6061 17.3578 13.4349 16.7284C12.9929 16.9113 12.5083 17.0123 12.0001 17.0123C11.4686 17.0123 10.9628 16.9018 10.5046 16.7026C9.6058 16.9537 8.93806 17.4426 8.45714 18.0216C7.73824 18.8871 7.42119 19.9747 7.42119 20.8252C7.42119 21.1565 7.15256 21.4252 6.82119 21.4252C6.48982 21.4252 6.22119 21.1565 6.22119 20.8252C6.22119 19.7155 6.62335 18.3512 7.53406 17.2549C7.99579 16.699 8.58446 16.2171 9.30665 15.8734C8.64995 15.1973 8.24561 14.2747 8.24561 13.2577ZM12.0001 10.7032C10.5893 10.7032 9.44561 11.8469 9.44561 13.2577C9.44561 14.6685 10.5893 15.8123 12.0001 15.8123C13.411 15.8123 14.5547 14.6685 14.5547 13.2577C14.5547 11.8469 13.411 10.7032 12.0001 10.7032Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
